import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateInventoryFormData } from "../schema/UpdateInventorySchema";
import { InventoryResponseSchema } from "../response/UpdateInventoryResponse";

export const useUpdateInventory = () => {
    return useMutation({
        mutationFn: async (values: {
            inventoryId: string;
            formData: UpdateInventoryFormData;
        }) => privateApi.put(`/v4/inventory/${values.inventoryId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = InventoryResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update inventory data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update inventory', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory data format");
            } else {
                console.error('Failed to update inventory', error);
                throw error;
            }
        },
    });
};
